<div class="login-background-container">
<mat-card id="loginCard">
  <mat-card-title><span style="font-size: 24px;font-weight: 500;">Please Login</span></mat-card-title>
  <mat-card-content>

    <form [formGroup]="form" autocomplete="on" (ngSubmit)="submit()">

      <p>
       
          <input class="input-class" #username id="username" type="text" matInput placeholder="User name"
                 formControlName="username" autofocus
                 (keyup)="clearErrorMessage()" >
       
      </p>

      <p>
         <input #password class="input-class" id="password" type="password"
                [attr.autocomplete]="'current-password'" matInput placeholder="Password"
                 formControlName="password"
                 (keyup)="clearErrorMessage()" >

          <mat-icon class="show-hide-class" (click)="toggleAttribute($event)"
                    matTooltip="show password value"
                    *ngIf="attribute===false">visibility</mat-icon>
          <mat-icon class="show-hide-class" (click)="toggleAttribute($event)"
                    matTooltip="hide password value"
                    *ngIf="attribute===true">visibility_off </mat-icon>

      </p>

       <!-- Forgot password block -->
      <div style="text-align: right;"><span style="text-align: right;"> <a routerLink="/recovery">Forgot Password?</a></span></div>

      <!-- error and progress block -->

 	  <div style="height: 18px;">
      	<p *ngIf="error" class="error">Error: {{ error }} </p>
        <p *ngIf="!error" class="error">&nbsp;</p>
      </div>

 	  <div style="height: 8px;">
 	  	<span *ngIf="processingLogin" >
 	  		<p-progressBar color="green" mode="indeterminate" [style]="{height: '0.2rem', padding: '0px', overflow: 'hidden'}"></p-progressBar>
 	  	</span>
      </div>

      <!-- REMEMBER ME / LOGIN BLOCK -->
        <div class="card-footer-class">
           <div style="display: flex; padding-top:12px;height: 10px;">
           <mat-checkbox id="remember-me" name="rememberUser" binary="true" [(ngModel)]="rememberMe" [ngModelOptions]="{standalone: true}">Remember Me</mat-checkbox>
           </div>

         <div style="width:100%; text-align: right">
            <button id="login-button" type="submit" mat-button>Login</button>
          </div>
        </div>

        <!-- LOGIN HELP -->
        <div class="login-help-block">
            If you do not have a user login or have issues logging in
            <br />please contact: <a
                href="mailto:agency@theconnectorwga.org?subject=The Connector login inquiry">
            agency@theconnectorwga.org</a>
        </div>

    </form>
  </mat-card-content>
</mat-card>
</div>
